import { useVizChartTheme } from '../../hooks/useVizChartTheme';
import { useVizFormatters } from '../../hooks/useVizFormatters';
import { PieChartBlock } from '../../viz.types';
import { getPieChartSlices } from './pieChartBlock.utils';

export const usePieChartBlock = (block: PieChartBlock) => {
  const formatters = useVizFormatters(block.format);
  const chartTheme = useVizChartTheme();

  const { slices, total } = getPieChartSlices({
    slices: block.slices,
    sliceColors: chartTheme.seriesColors,
    sliceOpacities: chartTheme.seriesOpacities,
  });

  return { formatters, chartTheme, slices, total };
};
